export const SALE_ORDER_ROUTE = "/sale-orders";
